// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"App_snackbar__vtGNK","snackbar_success":"App_snackbar_success__HzKFi","snackbar_error":"App_snackbar_error__3AtBJ"};